import * as Objdict from "objdict"

import {getImageFromAnimation} from "./utility/animation.js"
import timer from "@frog/source/views/app/stage/utility/timer.js"
import pixel from "@frog/source/views/app/stage/utility/pixel.js"
import * as deathzone from "@frog/source/data/deathzone.js"
import sizes from "@frog/source/data/sizes.js"

export default function WorldTerrain(stage) {
    const views = []

    return {
        "key": "world",
        "type": "container",
        "children": Object.values(stage.world.blocks || []).map((block) => {
            if(block.position.z <= 0) {
                return
            }
            return {
                "key": "world/blocks/" + block.position.x + "x" + block.position.y + "x" + block.position.z,
                "position": pixel("terrain", {"x": block.position.x, "y": block.position.y, "z": block.position.z}),
                "image": getImage(block),
            }
        })
    }
}

function getImage(block) {
    if(block.animation != undefined) {
        return getImageFromAnimation(block.animation, timer.ms)
    }
    return block.image
}
